module.exports = __webpack_public_path__ + "static/media/fotocommunity.67c7aa74.png";